<template>
  <el-form ref="form"
           :model="form"
           :rules="rules"
           label-position="left">
    <el-form-item prop="name">
      <el-input
        v-model.trim="form.name"
        placeholder="用户名"></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input
        v-model="form.password"
        placeholder="密码"
        type="password"
        @keyup.native="keyup"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button
        :loading="loading"
        class="auth-submit"
        type="primary"
        @click="login">
        <i class="el-icon-check"></i>
      </el-button>
    </el-form-item>
    <div v-if="errorMsg !== ''"
         class="auth-error">{{ errorMsg }}
    </div>
    <div class="auth-bottom-tip">
      还未拥有账户？
      <router-link to="/register">
        注册
      </router-link>
    </div>
  </el-form>
</template>
<script>

export default {
  name: 'LoginForm',
  data () {
    return {
      loading: false,
      errorMsg: '',
      form: {
        name: '',
        password: '',
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 60,
            message: '请输入正确的用户名',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 60,
            message: '密码长度在 2 到 60 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    keyup (e) {
      const keyCode = e.keyCode || e.which || e.charCode
      if (keyCode === 13) {
        this.login()
      }
    },
    async login () {
      this.errorMsg = ''
      this.loading = true
      try {
        await this.$refs.form.validate()
        try {
          await auth.login(this.form)
          this.$emit('login')
        } catch (error) {
          if (!error.response) {
            this.errorMsg = '网络错误'
          } else {
            this.errorMsg = '登录失败，用户名或密码错误'
          }
          return Promise.reject(error)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
